const { cond } = require("lodash");

let recaptcha_site_key = $("meta[name='recaptcha-site-key']").attr("content"),
    page_elements = {};
$(function() {
    page_elements = {
        change_email_new_email_form: $("#change_email_new_email_form"),

        change_email_new_email_common_error: $(
            "#change_email_new_email_commom_error"
        ),

        //mobile
        change_mobile_auth_check_form: $("#change_mobile_auth_check_form"),
        change_mobile_form_common_error_element: $(
            "#change_mobile_common_error"
        ),
        change_mobile_auth_check_modal: $("#changeMobileAuthCheckModal"),

        change_mobile_verify_otp_modal: $("#changeMobileVerifyOtpModal"),

        change_mobile_new_mobile_common_error: $(
            "#change_mobile_new_mobile_commom_error"
        ),

        change_mobile_verify_otp_form: $("#change_mobile_verify_otp_form"),
        filter_payment: $("#gender2"),
        delete_account: $("#accountDelete"),
        change_mobile_verify_otp_common_error: $(
            "#change_mobile_verify_otp_common_error"
        ),
        // verify_email_otp_modal_countdown_timer: $("#verify_email_modal_timer"),
        verify_mobile_otp_modal_countdown_timer: $(
            "#verify_mobile_modal_timer"
        ),

        verify_email_modal_resend_otp_element: $(
            "#verify_email_modal_resend_otp1"
        ),
        verify_mobile_modal_resend_otp_element: $(
            "#verify_mobile_modal_resend_otp"
        ),

        request_otp_for_login: $(".js-request-otp"),
        request_otp_for_change_mobile: $(".js-request-otp-mobile"),

        /* New codes */
        auth_check_modal: $("#authCheckModal"),
        auth_check_form: $("#auth_check_form"),
        credential_common_error_element: $("#credential_common_error"),
        change_email_new_email_modal: $("#changeEmailNewEmailModal"),
        change_mobile_new_mobile_modal: $("#changeMobileNewMobileModal"),
        change_mobile_new_mobile_form: $("#change_mobile_new_mobile_form"),
        verify_otp_modal: $("#VerifyOtpModal"),
        verify_otp_form: $("#verify_otp_form"),

        resend_otp: $(".js-resend-otp"),
        verify_storage: "verify",
        verify_otp_common_error: $("#verify_otp_common_error"),

        otp_modal_timer: $("#otp_modal_timer")
    };

    page_elements.verify_email_modal_resend_otp_element.removeClass(
        "d-inline-block"
    );
    page_elements.verify_email_modal_resend_otp_element.addClass("hide");

    $.each($('.iti input'), function() {
        $(this).attr('placeholder', 'Enter your mobile number');
    })

    $('#authCheckModal .iti input').attr('placeholder', 'Enter your registered email or phone number');
    $('#security .iti input').attr('placeholder', '');
    // phone change modal
    $("#changeMobileNewMobileModal").on("show.bs.modal", function(e) {
        let type = $(e.relatedTarget).attr("data-type");
        if (type == "ADD_NUMBER") {
            $("#changeMobileNewMobileModal .modal-title").text(
                "Add Mobile Number"
            );
        } else if (type == "EDIT_NUMBER") {
            $("#changeMobileNewMobileModal .modal-title").text(
                "Change Mobile Number"
            );
        }
        $(this).find('#phone3').attr('placeholder', 'Enter your mobile number');
    });

    $(".new-email").keypress(function(e) {
        if (e.which == 13) {
            $(page_elements.change_email_new_email_form).validate({
                rules: {
                    new_email: {
                        required: true,
                        email: true
                    }
                }
            });
            if ($(page_elements.change_email_new_email_form).valid()) {
                $("#change-email-btn").click();
                return false;
            }
        }
    });

    $("#change-email-btn").on("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        let _this = $(this),
        current_form = _this;
        $(page_elements.change_email_new_email_form).validate({
            rules: {
                new_email: {
                    required: true,
                    email: true
                }
            }
        });
        let formTypeData = "continue",
            formChangeType = "change-email";

        if ($(page_elements.change_email_new_email_form).valid()) {
            let form_action = $(page_elements.change_email_new_email_form).data(
                    "action"
                ),
                user_name = $(page_elements.change_email_new_email_form)
                    .find(".new-email")
                    .val(),
                form_data = $(
                    page_elements.change_email_new_email_form
                ).serialize();
            form_data =
                form_data + "&username=" + encodeURIComponent(user_name);

            grecaptcha.ready(function() {
                grecaptcha
                    .execute(recaptcha_site_key, { action: "submit" })
                    .then(function(token) {
                        // Add your logic to submit to your backend server here.
                        form_data =
                            form_data +
                            "&captcha_token=" +
                            encodeURIComponent(token);

                        CommonMethods.ajax({
                            url: form_action,
                            type: "POST",
                            data: form_data,
                            async: true,
                            success: NewDataCheckSuccessHandler.bind(
                                _this,
                                formTypeData,
                                formChangeType,
                                current_form
                            ),
                            error: NewDataCheckErrorHandler.bind(_this)
                        });
                    });
            });
        }
    });

    $(".js-change-mobile").on("click", function() {
        window.clearTimeout();
        clearTimeout(currentTimer);
        clearTimeout(expire_time);
        page_elements.auth_check_form
            .find(".js-modal-title")
            .text("Change Phone Number");
        page_elements.auth_check_form.attr("data-type", "change-mobile");
    });
    $(".js-change-email").on("click", function() {
        page_elements.auth_check_form
            .find(".js-modal-title")
            .text("Change Email Address");
        page_elements.auth_check_form.attr("data-type", "change-email");
    });

    $(".js-btn-add-Number").on("click", function () {
    	$("#auth_check_form").attr("data-type", "change-mobile");
    	$("#security-tab").tab("show");
	$(".js-change-mobile").trigger("click");
    });

    //hide resend otp INITIALLY
    page_elements.verify_email_modal_resend_otp_element.hide();
    page_elements.verify_mobile_modal_resend_otp_element.hide();

    CommonMethods.removeFromStorage(page_elements.verify_storage);
    //resend otp on ,auth by otp modals
    // page_elements.change_email_otp_auth_verify_otp_resend_otp.hide();

    let resendOtpDelayMinutes = 0.05;

    let csrfToken = $('meta[name="csrf-token"]').attr("content");
    page_elements.resend_otp.not(":disabled").on("click", resendOTP);

    //change email and phone number by click on continue btn
    page_elements.auth_check_form.on("submit", function(e) {
        e.preventDefault();
        e.stopPropagation();
        let formType = "continue",
            formChangeType = $(this).attr("data-type");
        page_elements.credential_common_error_element
            .addClass("d-none")
            .removeClass("ui-alert")
            .find("p")
            .text();
        $(this)
            .find(".is-invalid")
            .removeClass("is-invalid");
        $(this).validate({
            rules: {
                username: {
                    required: true
                }
                // password: { required: true, minlength: 6 }
            }
        });

        if (!$(this).valid()) {
            page_elements.credential_common_error_element
                .removeClass("d-none")
                .addClass("ui-alert")
                .find("p")
                .text("Fill the correct credentials");
        } else {
            // $(this)
            //     .find("button[type='submit']")
            //     .attr("disabled", "disabled");
            let authCredentials = $(this).serialize();
            let authCheckUrl = $(this).data("action");
            $.ajax({
                url: authCheckUrl,
                type: "POST",
                data: authCredentials,
                dataType: "json",
                headers: {
                    "X-CSRF-TOKEN": csrfToken
                },
                statusCode: {
                    411: function () {
                        $('div.modal').removeClass('show');
                        window.location.href = '/profile';
                    }
                },
                success: AuthCheckSuccessHandler.bind(
                    this,
                    formType,
                    formChangeType
                ),
                error: AuthCheckErrorHandler,
                complete: function() {
                    page_elements.auth_check_form
                        .find("button[type='submit']")
                        .removeAttr("disabled");
                }
            });
        }
    });

    $('#VerifyOtpModal').on('hide.bs.modal', function() {
        clearTimeout(currentTimer);
        clearTimeout(expire_time)
    })

    /* Authentication check success handler */
    let AuthCheckSuccessHandler = function(formType, formChangeType, result) {
        page_elements.credential_common_error_element
            .removeClass("d-none")
            .addClass();
        CommonMethods.setToStorage(page_elements.verify_storage, result.data);

        $("#authCheckModal").modal("hide");
        if (formType == "request-otp") {
            requestOtpChangeMobileEmail(formType, formChangeType);
            window.clearTimeout();
            clearTimeout(currentTimer);
            clearTimeout(expire_time);
            let timerOn = true,
            setTime = false;

            function timer(remaining) {
                var m = Math.floor(remaining / 60);
                var s = remaining % 60;

                m = m < 10 ? "0" + m : m;
                s = s < 10 ? "0" + s : s;
                document.getElementById("otp_modal_timer").innerHTML =
                    m + ":" + s;
                remaining -= 1;

                if (remaining >= 0 && timerOn) {
                    setTime = true;
                    setTimeout(function() {
                        timer(remaining);
                    }, 1000);
                    return;
                }

                if (!timerOn) {
                    return;
                }
                page_elements.verify_email_modal_resend_otp_element.removeClass(
                    "hide"
                );
                document.getElementById("otp_modal_timer").innerHTML =
                    "Time up!";
                $(".otp_input").attr("disabled", "disabled");
            }
            let expire_time = $("#expire_time").val();
            if(result.data.otp) {
                document.getElementById("verify-email-test-otp").innerHTML =
                    result.data.otp;
            }
            expire_time = expire_time * 60;
            if(!setTime) {
                timer(expire_time);
            }
        } else {
            if (formChangeType == "change-email") {
                $("#changeEmailNewEmailModal").modal("show");
                newEmailFormSubmission(formType, formChangeType);
            } else {
                $("#changeMobileNewMobileModal").modal("show");
                newMobileSubmission(formType, formChangeType);
            }
        }

        // page_elements.change_email_verify_otp_modal.toggle();
    };

    /* Authentication check error handler */
    let AuthCheckErrorHandler = function(jqXHR, textStatus, error) {
        let response = jqXHR.responseText;
        if (response) {
            response = JSON.parse(response);

            // page_elements.change_email_form_common_error_element
            //     .removeClass("d-none")
            //     .addClass("ui-alert");

            if (jqXHR.status == 422) {
                let validateErrors = response.errors;
                let firstErrorKey = Object.keys(validateErrors)[0];
                let firstValidationError = validateErrors[firstErrorKey][0];
                if (firstErrorKey) {
                    $('input[name="' + firstErrorKey + '"]')
                        .parent()
                        .addClass("is-invalid");
                    $('input[name="' + firstErrorKey + '"]').addClass(
                        "is-invalid"
                    );
                }
                page_elements.credential_common_error_element
                    .removeClass("d-none")
                    .addClass("ui-alert")
                    .find("p")
                    .text(firstValidationError);
            } else {
                page_elements.credential_common_error_element
                    .removeClass("d-none")
                    .addClass("ui-alert")
                    .find("p")
                    .text(response.message);
            }
        } else {
            page_elements.credential_common_error_element
                .addClass("ui-alert")
                .removeClass("d-none")
                .find("p")
                .text("Please check your network connection");
        }
    };

    /* New email submission */
    function newEmailFormSubmission(formType, formChangeType) {
        let formTypeData = formType,
            current_form = $(page_elements.change_email_new_email_form);
        $("#change-email-btn").on("click", function(e) {
            e.preventDefault();
            e.stopPropagation();

            $(page_elements.change_email_new_email_form).validate({
                rules: {
                    new_email: {
                        required: true,
                        email: true
                    }
                }
            });

            if (!$(page_elements.change_email_new_email_form).valid()) {
                // page_elements.change_email_new_email_common_error
                //     .addClass("d-flex ui-alert")
                //     .removeClass("d-none ui-alert-success")
                //     .find("p")
                //     .text("Please enter a valid email");
                // return;
            } else {
                let form_action = $(
                        page_elements.change_email_new_email_form
                    ).data("action"),
                    user_name = $(page_elements.change_email_new_email_form)
                        .find(".new-email")
                        .val(),
                    form_data = $(
                        page_elements.change_email_new_email_form
                    ).serialize();
                form_data =
                    form_data + "&username=" + encodeURIComponent(user_name);

                CommonMethods.ajax({
                    url: form_action,
                    type: "POST",
                    data: form_data,
                    async: true,
                    success: NewDataCheckSuccessHandler.bind(
                        this,
                        formTypeData,
                        formChangeType,
                        current_form
                    ),
                    error: NewDataCheckErrorHandler.bind(this)
                });
                // $.ajax({
                //     url: sendOtpUrl,
                //     type: "POST",
                //     data: formData,
                //     dataType: "json",
                //     headers: {
                //         "X-CSRF-TOKEN": csrfToken
                //     },
                //     success: NewDataCheckSuccessHandler.bind(this),
                //     error:NewDataCheckErrorHandler,
                //     // error: function(xhrObject, status, error) {
                //     //     let response = xhrObject.responseText;

                //     //     if (response) {
                //     //         response = JSON.parse(response);

                //     //         if (xhrObject.status == 422) {
                //     //             let errors = response.errors;
                //     //             let firstErrorKey = Object.keys(errors)[0];
                //     //             let firstError = errors[firstErrorKey][0];

                //     //             page_elements.change_email_new_email_common_error
                //     //                 .removeClass("d-none")
                //     //                 .addClass("ui-alert");

                //     //             page_elements.change_email_new_email_common_error
                //     //                 .find("p")
                //     //                 .text(firstError);
                //     //         } else {
                //     //             let generalMessage = response.message;
                //     //             page_elements.change_email_new_email_common_error
                //     //                 .addClass("ui-alert")
                //     //                 .removeClass("d-none")
                //     //                 .find("p")
                //     //                 .text(generalMessage);
                //     //         }
                //     //     } else {
                //     //         page_elements.change_email_new_email_common_error
                //     //             .addClass("ui-alert")
                //     //             .removeClass("d-none")
                //     //             .find("p")
                //     //             .text("Please check you network connection");
                //     //     }
                //     // }
                // });
            }
        });
    }

    /* New phone number submission */
    function newMobileSubmission(formType, formChangeType) {
        let formTypeData = formType,
        current_form = page_elements.change_mobile_new_mobile_form;
        clearTimeout(expire_time);
        clearTimeout(currentTimer);
        window.clearTimeout();
        page_elements.change_mobile_new_mobile_form.on("submit", function(e) {
            e.preventDefault();
            e.stopPropagation();
            if($(this).parents('.modal[data-status="addNewNumber"]').length > 0) {

                $(this).validate({
                    rules: {
                        new_mobile: {
                            required: true,
                            minlength: 6,
                            maxlength: 15
                        }
                    },
                    errorPlacement: function(error, element) {
                        $(element).css("border-color", "red");
                        return false;
                    }
                });
                if (!$(this).valid()) {
                    page_elements.change_mobile_new_mobile_common_error
                        .addClass("d-flex ui-alert error")
                        .removeClass("d-none")
                        .find("p")
                        .text("Please enter a valid mobile");
                    // return;
                } else {
                    let form_action = $(this).data("action"),
                        user_name = $(this)
                            .find(".new-mobile")
                            .val(),
                        form_data = $(this).serialize();
                    form_data = form_data + "&username=" + user_name;
                    grecaptcha.ready(function() {
                        grecaptcha
                            .execute(recaptcha_site_key, { action: "submit" })
                            .then(function(token) {
                                form_data = form_data + "&captcha_token=" + token;
                                CommonMethods.ajax({
                                    url: form_action,
                                    type: "POST",
                                    data: form_data,
                                    async: true,
                                    success: NewDataCheckSuccessHandler.bind(
                                        this,
                                        formTypeData,
                                        formChangeType,
                                        current_form
                                    ),
                                    error: NewDataCheckErrorHandler.bind(this)
                                });
                            });
                    });
                }
            }
        });
    }
    $('#authCheckModal').on('hide.bs.modal', function() {
        $('#authCheckModal').removeAttr('data-status');
    });
    /* New data (email or phone number) success handler */
    let NewDataCheckSuccessHandler = function(
        formTypeData = "continue",
        formChangeType,
        current_form,
        result
    ) {

        if (result.data.otp) {
            CommonMethods.setToStorage(
                page_elements.verify_storage,
                result.data
            );
            document.getElementById("verify-email-test-otp").innerHTML =
                result.data.otp;

            if (formChangeType == "change-email") {
                page_elements.verify_otp_form
                    .find(".js-msg-text")
                    .text("Please enter the OTP sent to your email");
            } else {
                page_elements.verify_otp_form
                    .find(".js-msg-text")
                    .text("Please enter the OTP sent to your mobile");
            }
            $(".otp_input").removeAttr("disabled");
            $(".otp_input").val("");

            timerOn = false;
            clearTimeout(expire_time);
            window.clearTimeout();

            var otpTimer = $("#otp_modal_timer").val();
            if (otpTimer) {
                document.getElementById("otp_modal_timer").remove();
            }

            timerOn = true;

            expire_time = $("#expire_time").val();
            document.getElementById("verify-email-test-otp").innerHTML =
                result.data.otp;
            expire_time = expire_time * 60;
            $(".otp_input").removeAttr("disabled");

            timer(expire_time, $("#timer-div span"), function() {
                page_elements.resend_otp.removeClass("hide");
                $("#timer-div span").text("Time Up!");
                $(".otp_input").attr("disabled", "disabled");
                $("#verify_email_modal_resend_otp1").show();
            });
        } else {
            CommonMethods.setToStorage(
                page_elements.verify_storage,
                result.data
            );
            if (formChangeType == "change-email") {
                page_elements.verify_otp_form
                    .find(".js-msg-text")
                    .text("Please enter the OTP sent to your email");
            } else {
                page_elements.verify_otp_form
                    .find(".js-msg-text")
                    .text("Please enter the OTP sent to your mobile");
            }
            $(".otp_input").removeAttr("disabled");
            $(".otp_input").val("");

            timerOn = false;
            clearTimeout(expire_time);
            window.clearTimeout();

            var otpTimer = $("#otp_modal_timer").val();
            if (otpTimer) {
                document.getElementById("otp_modal_timer").remove();
            }

            timerOn = true;

            expire_time = $("#expire_time").val();
            expire_time = expire_time * 60;
            $(".otp_input").removeAttr("disabled");

            timer(expire_time, $("#timer-div span"), function() {
                page_elements.resend_otp.removeClass("hide");
                $("#timer-div span").text("Time Up!");
                $(".otp_input").attr("disabled", "disabled");
                $("#verify_email_modal_resend_otp1").show();
            });
        }
        //TODO: test otp to show
        current_form
            .find("button[type='submit']")
            .attr("disabled", "disabled");
        let otp = result.data.otp;

        current_form
            .parents(".modal")
            .hide();
        page_elements.verify_otp_modal.show();
        page_elements.verify_otp_form.on("submit", function(e) {
            e.preventDefault();
            e.stopPropagation();

            page_elements.verify_otp_common_error.addClass("d-none");
            let verifyOtpUrl = "";
            if (formChangeType == "change-email") {
                verifyOtpUrl = $(this).data("action");
            } else {
                verifyOtpUrl = $(this).data("action-mobile-1");
            }

            let otpValue = "";
            let inputElements = $(this)
                .find("input[type='number']")
                .each(function(index) {
                    let inputValue = $(this).val();
                    otpValue += inputValue;
                });
            $.ajax({
                url: verifyOtpUrl,
                type: "POST",
                dataType: "json",
                data: {
                    otp: otpValue
                },
                headers: {
                    "X-CSRF-TOKEN": csrfToken
                },
                statusCode: {
                    411: function () {
                        $('div.modal').removeClass('show');
                        window.location.href = '/profile';
                    }
                },
                success: function(response) {
                    page_elements.verify_otp_form.trigger("reset");
                    if (formTypeData == "request-otp") {
                        page_elements.change_email_new_email_modal.toggle();
                    } else {
                        page_elements.verify_otp_modal.toggle();
                    }

                    $(".modal-backdrop").removeClass("modal-backdrop");

                    $(".ui-alert-success")
                        .removeClass("d-none")
                        .find("p")
                        .text("Your email has been updated successfully");

                    var baseurl =
                        window.location.origin + window.location.pathname;
                    window.location.replace(baseurl);
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    let response = jqXHR.responseText;
                    if (response) {
                        response = JSON.parse(response);
                        let generalMessage = response.message;
                        $(".otp_input").val("");
                        $("#verify_otp_form")
                            .find("button[type='submit']")
                            .addClass("ui-disabled");

                        page_elements.verify_otp_common_error
                            .removeClass("text-success d-none")
                            .addClass("text-danger")
                            .text(generalMessage);
                        if (generalMessage == "Attempt exceeded, resend OTP") {
                            page_elements.verify_email_modal_resend_otp_element.removeClass(
                                "hide"
                            );
                            page_elements.verify_email_modal_resend_otp_element.addClass(
                                "d-inline-block"
                            );

                            $("#otp_modal_timer").addClass("hide");
                            $("#otp_modal_timer").removeClass("d-inline-block");
                        }
                    } else {
                        page_elements.verify_otp_common_error
                            .removeClass("text-success d-none")
                            .addClass("text-danger")
                            .text("Please check your network connection");
                    }
                }
            });
        });
    };

    let NewDataCheckErrorHandler = function(response) {
        let _this = $(this);
        if (response.status == 422) {
            if (_this.attr("id") == "change_mobile_new_mobile_form") {
                _this
                    .find(".new-mobile")
                    .addClass("error")
                    .css("color", "red !important");
                _this
                    .find(".js-error-block")
                    .addClass("ui-alert ui-alert-success")
                    .removeClass("ui-alert-success d-none hide")
                    .text("Already exist!");
            } else {
                _this
                    .parents("form")
                    .find(".new-email")
                    .addClass("error");
                _this
                    .parents("form")
                    .find(".js-error-block")
                    .addClass("ui-alert")
                    .removeClass("d-none")
                    .text("Already exist!");
            }

            // $(".js-common-error")
            //     .text("All inputs are required")
            //     .removeClass("hide");
            // $.each(response.responseJSON.errors, function(key, value) {
            //     console.log(_this);
            //     _this.find('.js-error-block')
            //     .addClass("ui-alert-danger")
            //     .removeClass("ui-alert-success d-none")
            //     .text(value.join("<br>"));
            // });
        } else {
            _this
                .find(".js-error-block")
                .addClass("ui-alert")
                .removeClass("d-none")
                .text("Please check your network connection");
        }
    };

    $(".new-email").on("keyup", function() {
        $(this)
            .parents("form")
            .find(".js-error-block")
            .addClass("d-none");
    });
    function requestOtpChangeMobileEmail(formType, formChangeType) {
        // page_elements.verify_otp_modal.toggle();
        $("#VerifyOtpModal").modal("show");

        page_elements.verify_otp_form.on("submit", function(e) {
            e.preventDefault();
            e.stopPropagation();

            page_elements.verify_otp_common_error.addClass("d-none");

            let verifyOtpUrl = "";
            if (formChangeType == "change-email") {
                verifyOtpUrl = $(this).data("action-2");
            } else {
                verifyOtpUrl = $(this).data("action-mobile-2");
            }

            let otpValue = "",
                inputElements = $(this)
                    .find("input[type='number']")
                    .each(function(index) {
                        let inputValue = $(this).val();
                        otpValue += inputValue;
                    });

            $.ajax({
                url: verifyOtpUrl,
                type: "POST",
                dataType: "json",
                data: {
                    otp: otpValue
                },
                headers: {
                    "X-CSRF-TOKEN": csrfToken
                },
                statusCode: {
                    411: function () {
                        $('div.modal').removeClass('show');
                        window.location.href = '/profile';
                    }
                },
                success: function(response) {
                    page_elements.verify_otp_modal.toggle();

                    if (formChangeType == "change-email") {
                        page_elements.change_email_new_email_modal.toggle();
                        newEmailFormSubmission(formType, formChangeType);
                    } else {
                        page_elements.change_mobile_new_mobile_modal.toggle();
                        newMobileSubmission(formType, formChangeType);
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    let response = jqXHR.responseText;

                    if (response) {
                        $("#otp_modal_timer").html("");
                        window.clearTimeout();
                        page_elements.verify_otp_form.trigger("reset");
                        response = JSON.parse(response);
                        let generalMessage = response.message;

                        page_elements.verify_otp_common_error
                            .removeClass("text-success d-none")
                            .addClass("text-danger")
                            .text(generalMessage);
                    } else {
                        page_elements.verify_otp_common_error
                            .removeClass("text-success d-none")
                            .addClass("text-danger")
                            .text("Please check your network connection");
                    }
                }
            });
        });
    }

    page_elements.filter_payment.on("change", function(e) {
        e.preventDefault();
        let month = $("#gender2").val();
        let url = $(this).data("action");
        $.ajax({
            url: url,
            type: "GET",
            data: {
                month: month
            },
            dataType: "json",
            headers: {
                "X-CSRF-TOKEN": csrfToken
            },
            statusCode: {
                411: function () {
                    $('div.modal').removeClass('show');
                    window.location.href = '/profile';
                }
            },
            //success: OtpGenerateSuccessHandler.bind(this),
            success: function(response) {
                if (response) {
                    let html = "";
                    $.each(response.data, function(i, value) {
                        html =
                            html +
                            '<tr><td class="ui-course-name ui-course-res" style="width:30%">' +
                            value.course.title +
                            '</td><td data-column="Date:" class="ui-date">' +
                            value.created_at_formated +
                            '</td><td data-column="Validity:" class="ui-validity">' +
                            value.expiery_date_format +
                            '</td><td data-column="Total Price:" class="ui-total">' +
                            value.price_format +
                            '</td><td data-column="Payment Type:" class="ui-type">' +
                            value.gateway_format +
                            "</td></tr>";
                    });
                    $(".payment_tbody").html(html);
                }
            },
            error: ""
            // complete: function() {
            //     page_elements.auth_check_form
            //         .find("button[type='submit']")
            //         .removeAttr("disabled");
            // }
        });
    });

    //Request OTP
    page_elements.request_otp_for_login.on("click", function(e) {
        e.preventDefault();
        e.stopPropagation();

        page_elements.credential_common_error_element
            .addClass("d-none")
            .removeClass("ui-alert")
            .find("p")
            .text();
        let requestOtpForm = $(this).parents("#auth_check_form"),
            formType = "request-otp",
            formChangeType = $(this)
                .parents("#auth_check_form")
                .attr("data-type");

        requestOtpForm.validate({
            rules: {
                username: {
                    required: true
                }
            }
        });
        if (!requestOtpForm.valid()) {
            page_elements.credential_common_error_element
                .removeClass("d-none")
                .addClass("ui-alert")
                .find("p")
                .text("Fill the correct credentials");
        } else {
            requestOtpForm
                .find("button[type='submit']")
                .attr("disabled", "disabled");
            let form_data = requestOtpForm.serialize();
            let form_action = requestOtpForm.data("generate-otp");
            //let form_data = new FormData($(this).parents('form')[0]);

            $.ajax({
                url: form_action,
                type: "POST",
                data: form_data,
                dataType: "json",
                headers: {
                    "X-CSRF-TOKEN": csrfToken
                },
                statusCode: {
                    411: function () {
                        $('div.modal').removeClass('show');
                        window.location.href = '/profile';
                    }
                },
                //success: OtpGenerateSuccessHandler.bind(this),
                success: AuthCheckSuccessHandler.bind(
                    this,
                    formType,
                    formChangeType
                ),
                error: AuthCheckErrorHandler,
                complete: function() {
                    page_elements.auth_check_form
                        .find("button[type='submit']")
                        .removeAttr("disabled");
                }
            });
        }
    });

    ////////// Resend OTP ////////////////

    /**
     * User resend OTP for login or changing login parameters
     * @param {JSON} event
     */
    function resendOTP(event) {
        event.preventDefault();
        let form_data = new FormData(),
            form_action = $(this).attr("data-action"),
            verify_data = CommonMethods.getFromStorage(
                page_elements.verify_storage
            );

        //  validate the data
        if (!verify_data.source_type && !verify_data.source_value) {
            CommonMethods.alert(
                "Error",
                "Something went wrong!",
                "error",
                {
                    timer: 5000
                },
                CommonMethods.redirect.bind($, window.config.login)
            );
        }

        page_elements.verify_otp_common_error.addClass("d-none");

        //disable form, submit btn and show loader icon
        // $(event.target).attr("disabled", "disabled");
        // page_elements.verify_otp.form
        //     .find(".is-invalid")
        //     .removeClass("is-invalid")
        //     .end();
        // page_elements.verify_otp.common_error.addClass("hide");

        form_data.append("username", verify_data.source_value);
        form_data.append(
            "country_code",
            verify_data.country_code ? verify_data.country_code : 91
        );
        form_data.append("type", verify_data.source_type);
        form_data.append("has_login", verify_data.has_login);

        grecaptcha.ready(function() {
            grecaptcha
                .execute(recaptcha_site_key, { action: "submit" })
                .then(function(token) {
                    form_data.append("captcha_token", token);
                    CommonMethods.ajax({
                        url: form_action,
                        type: "POST",
                        data: form_data,
                        async: true,
                        success: successResendOTPHandler.bind(this),
                        error: function(response) {
                            page_elements.verify_otp_common_error
                                .text("Technical error!")
                                .removeClass("hide");
                            $(".otp_input").val("");
                        },
                        complete: function() {
                            $(event.target)
                                .find('button[type="submit"]')
                                .removeClass("ui-show-loader")
                                .removeAttr("disabled")
                                .end()
                                .find("input,select")
                                .removeAttr("readonly");
                        }
                    });
                });
        });
    }

    /**
     * Success handle for resend otp
     *
     */
    function successResendOTPHandler(response) {
        if (response.success) {
            page_elements.resend_otp.addClass("hide");
            clearTimeout(currentTimer);
            CommonMethods.setToStorage(
                page_elements.verify_storage,
                response.data
            );
            //add up
            // expire_time = $("#expire_time").val();
            // document.getElementById("verify-email-test-otp").innerHTML =
            //     response.data.otp;
            // expire_time = expire_time * 60;
            // $(".otp_input").removeAttr("disabled");
            // // timer(expire_time);
            // timerOn = false;
            // clearTimeout(expire_time);
            // window.clearTimeout();
            //addup end

            // let delayTime = resendOtpDelayMinutes * 60;
            // timer(delayTime, $("#otp_modal_timer2"), () => {
            //     page_elements.verify_email_modal_resend_otp_element.toggle();
            // });
            if (response.data.otp) {
                document.getElementById("verify-email-test-otp").innerHTML =
                    response.data.otp;
            }
            window.clearTimeout();
            // $('#otp_modal_timer').val('');
            $(".otp_input").removeAttr("disabled");
            $(".otp_input").val("");
            let timerOn = true;
            // document.getElementById("otp_modal_timer").remove();

            // function timer(remaining) {
            //     var m = Math.floor(remaining / 60);
            //     var s = remaining % 60;

            //     m = m < 10 ? "0" + m : m;
            //     s = s < 10 ? "0" + s : s;
            //     document.getElementById("timer-div").innerHTML =
            //         '<span class="ui-time-expire ui-mb25 d-inline-block " href="#" id="otp_modal_timer2">' +
            //         m +
            //         ":" +
            //         s +
            //         "</span>";
            //     remaining -= 1;

            //     if (remaining >= 0 && timerOn) {
            //         setTimeout(function() {
            //             timer(remaining);
            //         }, 1000);
            //         return;
            //     }

            //     if (!timerOn) {
            //         return;
            //     }
            //     // page_elements.resend_otp.removeClass("hide");
            //     // page_elements.verify_email_modal_resend_otp_element.removeClass(
            //     //     "hide"
            //     // );
            //     // page_elements.verify_email_modal_resend_otp_element.addClass(
            //     //     "d-inline-block"
            //     // );
            //     document.getElementById("timer-div").innerHTML =
            //         '<span class="ui-time-expire ui-mb25" href="#" id="otp_modal_timer2">Time Up!</span>';
            //     $(".otp_input").attr("disabled", "disabled");
            // }
            expire_time = $("#expire_time").val();
            expire_time = expire_time * 60;
            // timer(expire_time);
            $("#otp_modal_timer").removeClass("hide");
            timer(expire_time, $("#timer-div span"), function() {
                page_elements.resend_otp.removeClass("hide");
                $("#timer-div span").text("Time Up!");
                $(".otp_input").attr("disabled", "disabled");
                $("#verify_email_modal_resend_otp1").show();
            });
        }
    }

    /**
     * Timer
     */
    let timerOn = true,
        currentTimer;

    function timer(remaining, element, callback) {
        clearTimeout(currentTimer);
        clearTimeout(expire_time);
        window.clearTimeout();
        let m = Math.floor(remaining / 60);
        let s = remaining % 60;

        m = m < 10 ? "0" + m : m;
        s = s < 10 ? "0" + s : s;
        element.text(m + ":" + s);
        remaining -= 1;

        if (remaining >= 0 && timerOn) {
            currentTimer = setTimeout(function() {
                timer(remaining, element, callback);
            }, 1000);
            return;
        }

        if (!timerOn) {
            // Do validate stuff here
            return;
        }

        // Do timeout stuff here
        callback();
    }

    // -----------------------------------------------------------------------------------------------------

    // page_elements.change_email_auth_check_modal.on("hide.bs.modal", function(
    //     e
    // ) {
    //     e.stopPropagation();
    //     $(this)
    //         .find("form")
    //         .trigger("reset");
    //     page_elements.change_email_form_common_error_element
    //         .addClass("d-none")
    //         .removeClass("ui-alert")
    //         .text("");
    // });

    //change mobile
    page_elements.change_mobile_auth_check_form.on("submit", function(e) {
        e.preventDefault();
        e.stopPropagation();

        page_elements.change_mobile_form_common_error_element
            .addClass("d-none")
            .removeClass("ui-alert")
            .find("p")
            .text();

        $(this).validate({
            rules: {
                username: {
                    required: true
                },
                password: {
                    required: true,
                    minlength: 6
                }
            }
        });

        if (!$(this).valid()) {
            page_elements.change_mobile_form_common_error_element
                .removeClass("d-none")
                .addClass("ui-alert")
                .find("p")
                .text("Fill the correct credentials");
        } else {
            $(this)
                .find("button[type='submit']")
                .attr("disabled", "disabled");
            let authCredentials = $(this).serialize();

            let authCheckUrl = $(this).data("action");
            $.ajax({
                url: authCheckUrl,
                type: "POST",
                data: authCredentials,
                dataType: "json",
                headers: {
                    "X-CSRF-TOKEN": csrfToken
                },
                statusCode: {
                    411: function () {
                        $('div.modal').removeClass('show');
                        window.location.href = '/profile';
                    }
                },
                success: changeMobileAuthCheckSuccessHandler,
                error: changeMobileAuthCheckErrorHandler,

                complete: function() {
                    page_elements.change_mobile_auth_check_form
                        .find("button[type='submit']")
                        .removeAttr("disabled");
                }
            });
        }
    });

    let changeMobileAuthCheckSuccessHandler = function(result) {
        page_elements.change_mobile_form_common_error_element
            .removeClass("d-none")
            .addClass();
        page_elements.change_mobile_auth_check_modal.toggle();
        page_elements.change_mobile_new_mobile_modal.toggle();
        formType = "continue";
        newMobileSubmission(formType);
    };

    let MobileChangeOtpGenerateSuccessHandler = function(result) {
        page_elements.change_mobile_form_common_error_element
            .removeClass("d-none")
            .addClass();
        page_elements.change_mobile_auth_check_modal.toggle();
        page_elements.verify_otp_modal.toggle();
        page_elements.verify_otp_form.on("submit", function(e) {
            e.preventDefault();
            e.stopPropagation();

            page_elements.change_mobile_verify_otp_common_error.addClass(
                "d-none"
            );

            let verifyOtpUrl = $(this).data("action-2");

            let otpValue = "";
            let inputElements = $(this)
                .find("input[type='text']")
                .each(function(index) {
                    let inputValue = $(this).val();
                    otpValue += inputValue;
                });

            $.ajax({
                url: verifyOtpUrl,
                type: "POST",
                dataType: "json",
                data: {
                    otp: otpValue
                },
                headers: {
                    "X-CSRF-TOKEN": csrfToken
                },
                statusCode: {
                    411: function () {
                        $('div.modal').removeClass('show');
                        window.location.href = '/profile';
                    }
                },
                success: function(response) {
                    page_elements.verify_otp_form.trigger("reset");
                    page_elements.verify_otp_modal.toggle();
                    page_elements.change_mobile_new_mobile_modal.toggle();
                    let formType = "request-otp";
                    newMobileSubmission(formType);
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    let response = jqXHR.responseText;
                    if (response) {
                        response = JSON.parse(response);
                        let generalMessage = response.message;

                        page_elements.change_mobile_verify_otp_common_error
                            .removeClass("text-success d-none")
                            .addClass("text-danger")
                            .text(generalMessage);
                    } else {
                        page_elements.change_mobile_verify_otp_common_error
                            .removeClass("text-success d-none")
                            .addClass("text-danger")
                            .text("Please check your network connection");
                    }
                },
                complete: function() {
                    page_elements.change_mobile_verify_otp_form
                        .find("button[type='submit']")
                        .removeAttr("disabled");
                }
            });
        });
    };

    let changeMobileAuthCheckErrorHandler = function(jqXHR, textStatus, error) {
        let response = JSON.parse(jqXHR.responseText);
        if (response) {
            if (jqXHR.status == 422) {
                let validateErrors = response.errors;
                let firstErrorKey = Object.keys(validateErrors)[0];
                let firstValidationError = validateErrors[firstErrorKey][0];

                page_elements.change_mobile_form_common_error_element
                    .addClass("ui-alert")
                    .removeClass("d-none")
                    .text(firstValidationError);
            } else {
                page_elements.change_mobile_form_common_error_element
                    .removeClass("d-none")
                    .addClass("ui-alert")
                    .text(response.message);
            }
        } else {
            page_elements.change_mobile_form_common_error_element
                .addClass("ui-alert")
                .removeClass("d-none")
                .text("Please check your network connection");
        }
    };

    //resend otp email
    page_elements.verify_email_modal_resend_otp_element.on("click", function(
        e
    ) {
        $(this).removeClass("d-inline-block");
        $(this).toggle();

        e.preventDefault();
        e.stopPropagation();
        let resendOtpUrl = $(this).data("action");
        resendOtpUrl = resendOtpUrl + "?username_type=email";
        // grecaptcha.ready(function() {
        //     grecaptcha
        //         .execute(recaptcha_site_key, { action: "submit" })
        //         .then(function(token) {
        //             $.ajax({
        //                 type: "POST",
        //                 url: resendOtpUrl,
        //                 dataType: "json",
        //                 data: { captcha_token: token },
        //                 headers: {
        //                     "X-CSRF-TOKEN": csrfToken
        //                 },
        //                 success: result => {
        //                     console.log("night");
        //                     let delayTime = resendOtpDelayMinutes * 60;
        //                     // page_elements.verify_email_modal_resend_otp_element.toggle();
        //                     timer(
        //                         delayTime,
        //                         page_elements.verify_email_otp_modal_countdown_timer,
        //                         () => {
        //                             page_elements.verify_email_modal_resend_otp_element.toggle();
        //                         }
        //                     );
        //                 },
        //                 error: (xhr, status, err) => {
        //                     page_elements.verify_email_modal_resend_otp_element.toggle();
        //                 }
        //             });
        //         });
        // });
    });

    //resend otp mobile
    page_elements.verify_mobile_modal_resend_otp_element.on("click", function(
        e
    ) {
        e.preventDefault();
        e.stopPropagation();

        $(this).removeClass("d-inline-block");
        $(this).toggle();
        let resendOtpUrl = $(this).data("action");
        resendOtpUrl = resendOtpUrl + "?username_type=mobile";
        // $.ajax({
        //     type: "POST",
        //     url: resendOtpUrl,
        //     dataType: "json",
        //     data: "",
        //     headers: {
        //         "X-CSRF-TOKEN": csrfToken
        //     },
        //     success: result => {
        //         let delayTime = resendOtpDelayMinutes * 60;
        //         // page_elements.verify_mobile_modal_resend_otp_element.toggle();
        //         timer(
        //             delayTime,
        //             page_elements.verify_mobile_otp_modal_countdown_timer,
        //             () => {
        //                 page_elements.verify_mobile_modal_resend_otp_element.toggle();
        //             }
        //         );
        //     },
        //     error: (xhr, status, err) => {
        //         page_elements.verify_mobile_modal_resend_otp_element.toggle();
        //     }
        // });
    });

    function requestOtp(resend=false){
            $("#delete_account_verify_otp_form .otp_input").removeAttr('disabled').val("");

            $("#delete_verify_otp_common_error").addClass("d-none");
        let csrf_token = $("#csrf-token").attr("content");

        grecaptcha.ready(function () {
            grecaptcha
                .execute(recaptcha_site_key, { action: "submit" })
                .then(function (token) {
                    let otp_url = $("#accountDelete").data("generate-otp-url")
                    form_data = { captcha_token: token, from_delete_account: true }
                    $.ajax({
                        url: otp_url, data: form_data, dataType: 'json', method: 'POST',
                        headers: { 'X-CSRF-TOKEN': csrf_token },
                        statusCode: {
                            411: function () {
                                $('div.modal').removeClass('show');
                                window.location.href = '/profile';
                            }
                        },
                        success: function (response) {
                            if(!resend){
                            $("#delete-account-one").hide();
                            $("#delete-account-verify-otp").show();
                            $("#delete_acc_resend_otp").hide();
                            }
                            else {
                                $("#delete_acc_resend_otp").hide();
                            }
                        },
                        error: function (error) {
                            console.log("cant send otp")
                            console.log(error)
                        }

                    })
                })
        })
        let expire_time = $("#expire_time").val()
        expire_time= expire_time * 60;
        timer(expire_time, $("#timer-div-delete span"), function () {
            // $("#delete_acc_resend_otp").removeClass("hide");
            $("#timer-div-delete span").text("Time Up!");
            $(".otp_input").attr("disabled", "disabled");
            $("#delete_acc_resend_otp").show();
        });
        }


    page_elements.delete_account.submit(function (e) {


        e.preventDefault();

        let reason = $("#delete-title").val();
        let url = $(this).data("action");

        //start

        requestOtp()

        $("#delete_account_verify_otp_form").on("submit", function (e) {
            e.preventDefault()
            e.stopPropagation()

            let otp_entered = "";
            let otp_wrap_elem = $("#delete-account-otp-group");
            let otp_digit_count = otp_wrap_elem.data("otp-digit-count");
            otp_wrap_elem
                .find("input")
                .each(function (index) {
                otp_entered += $(this).val();
            });

            let verifyOtpUrl=$("#delete-verify-otp-btn").data("action")
            let csrf=$("#csrf-token").attr("content")
            $.ajax({url:verifyOtpUrl,method:"POST",headers:{'X-CSRF-TOKEN':csrf},dataType:'json',
                data: { otp: otp_entered },
                statusCode: {
                    411: function () {
                        $('div.modal').removeClass('show');
                        window.location.href = '/profile';
                    }
                },
                success: function (response) {
                    $("#delete-account-verify-otp").toggle();
            $.ajax({
                url: url,
                type: "POST",
                data: {
                    reason: reason
                },
            dataType: "json",
            headers: {
                "X-CSRF-TOKEN": csrfToken
            },
            statusCode: {
                411: function () {
                    $('div.modal').removeClass('show');
                    window.location.href = '/profile';
                }
            },
            success: function(response) {
                if (response) {
                    window.location.reload(true);
                }
            },
            // complete: function() {
            //     page_elements.auth_check_form
            //         .find("button[type='submit']")
            //         .removeAttr("disabled");
            // }
        });
                },
            error: function (xhr) {
                    let generalMessage = xhr.responseJSON.message

                    let verifyOtpErr=$("#delete_verify_otp_common_error")
                if (generalMessage) {
                    verifyOtpErr.removeClass("d-none")
                    verifyOtpErr.addClass("text-danger")
                    verifyOtpErr.text(generalMessage)
                    }
                    else {
                        verifyOtpErr.removeClass("d-none")
                        verifyOtpErr.text("Please check your network connection")
                    }

                }
            })
        });

        $("#delete_acc_resend_otp").on("click", function (e) {
            e.preventDefault()
            e.stopPropagation()
            requestOtp(true)
        })
        //end


    });
    $('.modal').on('hide.bs.modal', function() {
        window.clearTimeout();
        clearTimeout(currentTimer);
        clearTimeout(expire_time);
    })
    $("#change_mobile_new_mobile_form").on("submit", function(e) {
        e.preventDefault();
        e.stopPropagation();
        let _this = $(this),
        current_form = $(this);
        if($(this).parents('.modal[data-status="addNewNumber"]').length < 1) {
            $(this).validate({
                    rules: {
                        new_mobile: {
                            required: true,
                            minlength: 6,
                            maxlength: 15
                        }
                    },
                    errorPlacement: function(error, element) {
                        $(element).css("border-color", "red");
                        return false;
                    }
                });
                let formTypeData = "continue",
                    formChangeType = "change-mobile";
                if (!$(this).valid()) {
                    page_elements.change_mobile_new_mobile_common_error
                        .addClass("d-flex ui-alert error")
                        .removeClass("d-none")
                        .find("p")
                        .text("Please enter a valid mobile");
                    // return;
                } else {
                    let form_action = $(this).data("action"),
                        user_name = $(this)
                            .find(".new-mobile")
                            .val(),
                        form_data = $(this).serialize();
                    form_data = form_data + "&username=" + user_name;

                    grecaptcha.ready(function() {
                        grecaptcha
                            .execute(recaptcha_site_key, { action: "submit" })
                            .then(function(token) {
                                form_data = form_data + "&captcha_token=" + token;

                                // Add your logic to submit to your backend server here.
                                CommonMethods.ajax({
                                    url: form_action,
                                    type: "POST",
                                    data: form_data,
                                    async: true,
                                    beforeSend: function() {
                                        _this.trigger('reset');
                                    },
                                    success: NewDataCheckSuccessHandler.bind(
                                        _this,
                                        formTypeData,
                                        formChangeType,
                                        current_form
                                    ),
                                    error: NewDataCheckErrorHandler.bind(_this)
                                });
                            });
                    });
                }
        }
    });

});

//$(document).on('click', '.js-btn-add-Number', function() {
    //$('#authCheckModal').attr('data-status', 'addNewNumber');
//})

// OTP input wrap
let that = $('#delete-account-otp-group');
$('#delete-account-otp-group')
    .find("input")
    .each(function() {
        let otpInput = that.find("input"),
            submit = that.parents("form").find('button[type="submit"]');
        $(this).attr("maxlength", 1);
        $(this).on("keypress", function(e) {
            if (e.keyCode !== 17) {
                e.preventDefault();
                $(this).val(e.key);
            }
        });
        $(this).on("keyup", function (e) {
            if (e.keyCode === 8 || e.keyCode === 37) {
                let prev = that.find("input").eq($(this).index() - 1);
                if (prev.length && $(this).index() != 0) {
                    $(prev).val('');
                    $(prev).select();
                }
            } else if (
                (e.keyCode >= 48 && e.keyCode <= 57) ||
                (e.keyCode >= 96 && e.keyCode <= 105) ||
                e.keyCode === 39
            ) {
                let next = that.find("input").eq($(this).index() + 1);
                if (next.length) {
                    if (!$(next).val()) {
                        $(next).select();
                    } else {
                        activateNextEmptyField();
                    }
                } else {
                    that.parents("form")
                        .find('button[type="submit"]')
                        .focus();
                }
            }
            let thisInput = $(this);
            if (!$(this).val()) {
                thisInput.removeClass("js-input-active");
            } else {
                thisInput.addClass("js-input-active");
            }
            activateNextEmptyField();
    });
});

$("#delete-account-otp-group input").bind("paste", function(e) {
    activateNextEmptyField();
});

function activateNextEmptyField() {
    var is_focus = true;
    $('#delete_account_verify_otp_form button[type="submit"]').addClass("ui-disabled");
    $.each($('input[name="OTP[]"]'), function(input_key, input_element) {
        if (!$(input_element).val()) {
            $(input_element).focus();
            is_focus = false;
            return false;
        }
    });
    if (is_focus) {
        $('#delete_account_verify_otp_form button[type="submit"]')
            .removeClass("ui-disabled")
            .focus();
    }
}

// mobile verify on click
$("#verifyMobile").on("click",function(e) {
    e.preventDefault();
    form_datas = {}
    $.ajax({
        url: mobile_url, data: form_datas, dataType: 'json', method: 'POST',
        headers: {'X-CSRF-TOKEN': csrf_token},
        // success: AuthCheckSuccessHandler.bind(this,'request-otp','verify-mobile'),
        success: function (response) {
            if(response.success) {
                $('#verifyMobile').css('display', 'none');
                var html = '<div class="alert alert-success ui-help-notification">\n' +
                    '                <span class="ui-icon-verified"></span><span>'+ response.message +'</span>\n' +
                    '            </div>';
                $('#verifyAlert').html(html);
                $("#VerifyOtpModals").modal("show");

                let currentTimer;
                window.clearTimeout();
                clearTimeout(currentTimer);
                clearTimeout(expire_time);
                let timerOn = true,
                    setTime = false;

                function timer(remaining) {
                    var m = Math.floor(remaining / 60);
                    var s = remaining % 60;

                    m = m < 10 ? "0" + m : m;
                    s = s < 10 ? "0" + s : s;
                    document.getElementById("otp_modal_timers").innerHTML =
                        m + ":" + s;
                    remaining -= 1;

                    if (remaining >= 0 && timerOn) {
                        setTime = true;
                        setTimeout(function() {
                            timer(remaining);
                        }, 1000);
                        return;
                    }

                    if (!timerOn) {
                        return;
                    }
                    page_elements.verify_email_modal_resend_otp_element.removeClass(
                        "hide"
                    );
                    document.getElementById("otp_modal_timers").innerHTML =
                        "Time up!";
                    $(".otp_input").attr("disabled", "disabled");
                    $("#js-otp-submit-btn").attr("disabled", "disabled");
                }
                let expire_time = $("#expire_times").val();
                if(response.data.otp) {
                    document.getElementById("verify-email-test-otps").innerHTML =
                        response.data.otp;
                }
                expire_time = expire_time * 60;
                if(!setTime) {
                    timer(expire_time);
                }
            }
        },
        error: function (error) {
            $('#verifyMobile').css('display','block');
            var html = '<div class="alert alert-danger ui-help-notification">\n' +
                '                <span class="ui-icon-failed"></span><span>Something went wrong. Try after some time!</span>\n' +
                '            </div>';
            $('#verifyAlert').html(html);
            console.log("cant send otp")
            console.log(error)
        }
    })
});

$('#verify_existing_otp_form').on("submit", function(e) {
    e.preventDefault();
    e.stopPropagation();

    page_elements.verify_otp_common_error.addClass("d-none");

    let verifyOtpUrl = $(this).data("action");

    let otpValue = "",
        inputElements = $(this)
            .find("input[type='number']")
            .each(function(index) {
                let inputValue = $(this).val();
                otpValue += inputValue;
            });
    $('#verify_otp_common_errors').addClass("d-none")

    $.ajax({
        url: verifyOtpUrl,
        type: "POST",
        dataType: "json",
        data: {
            otp: otpValue
        },
        headers: {
            "X-CSRF-TOKEN": csrf_token
        },
        statusCode: {
            411: function () {
                $('div.modal').removeClass('show');
                window.location.href = '/profile';
            }
        },
        success: function(response) {
            $("#verify_existing_otp_form").modal("hide");
            var html = '<div class="alert alert-success ui-help-notification">\n' +
                '                <span class="ui-icon-verified"></span><span>'+ response.message +'</span>\n' +
                '            </div>';
            $('#verifyAlert').html(html);
            window.location.href = '/profile';
        },
        error: function(error) {
            console.log(error.responseJSON);
            let msg = error.responseJSON.message;
            $("#otp_modal_timers").html("");
            $('#verify_otp_common_errors').removeClass("d-none").text(msg);
        }
    });
});
